import React from 'react';
import T from 'prop-types';
import NewFeatureRequestButton from '../../NewFeatureRequestButton';

const RequestAccess = ({ featureName, title, description }) => (
  <div className="request-access">
    <h1 className="request-access__title">{title}</h1>
    <p className="request-access__description">{description}</p>
    <NewFeatureRequestButton
      featureName={featureName}
      showErrorInTooltip
      buttonClassName="hms-btn request-btn btn-allow-access"
    />
  </div>
);

RequestAccess.propTypes = {
  featureName: T.string.isRequired,
  title: T.string,
  description: T.string,
};

export default RequestAccess;
